import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { TickerTape } from './TickerTape';
import { CursorGlow } from './CursorGlow';

export function Layout() {
  return (
    <>
      <CursorGlow />
      <ScrollToTop />
      <Header />
      <TickerTape />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
